import { render, staticRenderFns } from "./a22.vue?vue&type=template&id=0a5c177b&scoped=true"
import script from "./a22.vue?vue&type=script&lang=js"
export * from "./a22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c177b",
  null
  
)

export default component.exports